(() => {
  const panel = document.querySelector('[data-po-cart-help]');
  const source = document.getElementById('po-cart-labels');
  if (!panel || !source) return;
  const labels = JSON.parse(source.textContent);
  const busy = document.getElementById('ajaxBusy');
  if (busy && !busy.querySelector('.po-cart-busy-label')) {
    const label = document.createElement('span');
    label.className = 'po-cart-busy-label';
    label.setAttribute('role', 'status');
    label.textContent = labels.updating;
    busy.appendChild(label);
  }
  const button = panel.querySelector('[data-po-shipping-button]');
  if (!button) return;
  const zip = panel.querySelector('#po-shipping-zip');
  const status = panel.querySelector('[data-po-shipping-result]');
  const list = panel.querySelector('[data-po-shipping-rates]');
  const root = panel.dataset.cartRoot;
  const checkoutLink = panel.querySelector('[data-po-shipping-checkout]');
  if (checkoutLink) {
    checkoutLink.hidden = false;
    checkoutLink.addEventListener('click', () => {
      const checkout = document.querySelector('#cart-table [name="checkout"]');
      if (!checkout || checkout.disabled || checkout.getAttribute('aria-disabled') === 'true') {
        status.textContent = labels.checkout_pending;
        checkout?.scrollIntoView({block: 'center'});
        return;
      }
      checkout.click();
    });
  }
  let controller;
  let version = 0;
  let hasResult = false;
  const signature = cart => JSON.stringify([cart.total_price, cart.currency, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
  const request = async (url, options, signal) => {
    const response = await fetch(url, {cache:'no-store', ...options, signal});
    if (!response.ok) throw Error('HTTP ' + response.status);
    return response.json();
  };
  const invalidate = () => {
    version++;
    controller?.abort();
    controller = null;
    button.disabled = false;
    if (hasResult) status.textContent = labels.rates_changed;
    list.replaceChildren();
    hasResult = false;
  };
  const calculate = async () => {
    invalidate();
    const postcode = zip.value.replace(/\s/g, '');
    if (!/^\d{5}$/.test(postcode)) {
      status.textContent = labels.postcode_invalid;
      zip.setAttribute('aria-invalid','true');
      zip.focus();
      return;
    }
    zip.removeAttribute('aria-invalid');
    const run = version;
    const active = new AbortController();
    controller = active;
    const timeout = setTimeout(() => active.abort(), 25000);
    const params = new URLSearchParams({'shipping_address[zip]':postcode,'shipping_address[country]':'Sweden'});
    status.textContent = labels.calculating;
    button.disabled = true;
    hasResult = true;
    try {
      const before = await request(root + '.js', {}, active.signal);
      await request(root + '/prepare_shipping_rates.json?' + params, {method:'POST'}, active.signal);
      let data;
      for (let i = 0; i < 18; i++) {
        data = await request(root + '/async_shipping_rates.json?' + params, {}, active.signal);
        if (data !== null) break;
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      if (!data || !Array.isArray(data.shipping_rates)) throw Error('UNAVAILABLE');
      const after = await request(root + '.js', {}, active.signal);
      if (run !== version) return;
      if (signature(before) !== signature(after)) { status.textContent = labels.rates_changed; return; }
      status.textContent = data.shipping_rates.length ? labels.rates_found : labels.rates_missing;
      for (const rate of data.shipping_rates) {
        const price = Number(rate.price);
        if (!Number.isFinite(price) || price < 0) throw Error('INVALID_RATE');
        const item = document.createElement('li');
        const currency = rate.currency || after.currency || panel.dataset.currency;
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'sv', {style:'currency',currency}).format(price);
        item.textContent = (rate.presentment_name || rate.name) + ': ' + amount;
        list.appendChild(item);
      }
    } catch (error) {
      if (run === version) { list.replaceChildren(); status.textContent = labels.rates_failed; }
    } finally {
      clearTimeout(timeout);
      if (run === version) { button.disabled = false; controller = null; }
    }
  };
  button.addEventListener('click', calculate);
  zip.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); calculate(); } });
  zip.addEventListener('input', invalidate);
  const table = document.getElementById('cart-table');
  table.addEventListener('input', event => { if (event.target.matches('.item-qty')) invalidate(); });
  table.addEventListener('click', event => { if (event.target.closest('.qtybtn,.remove_item_multi')) invalidate(); });
  new MutationObserver(records => {
    if (records.some(record => record.target.matches?.('.cart-table,.item-qty,#total-cart-bottom') || Array.from(record.addedNodes).some(node => node.matches?.('.cart-table,#total-bottom,#total-top')))) invalidate();
  }).observe(table, {childList:true,subtree:true});
})();

